<template>
	<div>
		<div class="sense-main">
			<div class="sense-search">
				<el-row>
					<el-form label-width="68px">								
						<el-col :span="6" :offset="9">
							<el-form-item label="套餐名称">
								<el-input size="medium" v-model.trim="licenseSearchObj.packageName" maxlength="64"></el-input>
							</el-form-item>	
						</el-col>								
						<el-col :span="6">
							<el-form-item label="套餐状态">
								<el-select size="medium" v-model.trim="licenseSearchObj.status" maxlength="64">
									<el-option value="1" key="1" label="正常"></el-option>
									<el-option value="2" key="2" label="已用完"></el-option>
									<el-option value="3" key="3" label="已过期"></el-option>
								</el-select>
							</el-form-item>	
						</el-col>
						<el-col :span="3" class="text-right">
							<el-button class="search-btn" size="medium" @click="emptyLicenseSearch">清空</el-button>
							<el-button class="search-btn" size="medium" type="primary" @click="searchLicenseList">搜索</el-button>
						</el-col>									
					</el-form>
				</el-row>
			</div>
			<div class="sense-table-list">
				<div class="package-no-data" v-if="isReady == true && licenseListData.length == 0 && noDataObj.status == 1">您的账户没有可用套餐</div>
				<div class="package-no-data" v-if="isReady == true && licenseListData.length == 0 && noDataObj.status == 2">您的账户没有已用完套餐</div>
				<div class="package-no-data" v-if="isReady == true && licenseListData.length == 0 && noDataObj.status == 3">您的账户没有已过期套餐</div>
				<el-row style="margin-right: -30px;">
					<el-col :span="8" v-for="item in licenseListData" :key="item.packageGuid">
						<el-card class="sense-card-new">
							<div slot="header" class="card-new-header clearfix">
								<h3 class="fl sense-ellipsis" :title="item.packageName">{{ item.packageName }}</h3>
								<el-tag class="fr" size="mini" :type="item.status == 1?'success':'info'">{{ item.status | statusFilter}}</el-tag>
							</div>
							<ul class="card-new-con" v-if="item.packageType == 1">
								<li class="plat" v-if="item.detail.licenseForm == 2">
									<em v-if="item.detail.platform == 7" title="Windows" class="ssicon ss-windows"></em>
									<em v-if="item.detail.platform == 7" title="Linux" class="ssicon ss-linux"></em>
									<em v-if="item.detail.platform == 7" title="Mac" class="ssicon ss-mac"></em>
									<em v-if="(item.detail.platform & 24) > 0" title="Android" class="ssicon ss-android"></em>
									<em v-if="(item.detail.platform & 24) > 0" title="ARM Linux" class="arm-linux-big-icon"></em>
								</li>
								<li class="clearfix">
									<label class="fl">许可形式</label>
									<span class="fl">{{ item.detail.licenseForm | licenseFormFilter }}</span>
								</li>								
								<li class="clearfix">
									<label class="fl">许可数量</label>
									<span class="fl sense-ellipsis package-num">{{ item.detail.licenseCount | commonFilter }}/{{ item.detail.licenseTotal | commonFilter }} (剩余/总量)</span>
								</li>
								<li class="clearfix">
									<label class="fl">到期时间</label>
									<span class="fl">{{ item.expireTime }}</span>
								</li>
							</ul>
							<ul class="card-new-con" v-if="item.packageType == 2">										
								<li class="clearfix">
									<label class="fl">更新次数</label>
									<span class="fl sense-ellipsis package-num">{{ item.detail.updateCount | commonFilter }}/{{ item.detail.updateTotal | commonFilter }} (剩余/总量)</span>
								</li>
								<li class="clearfix">
									<label class="fl">到期时间</label>
									<span class="fl">{{ item.expireTime }}</span>
								</li>
							</ul>
							<ul class="card-new-con" v-if="item.packageType == 3">										
								<li class="clearfix">
									<label class="fl">计费方式</label>
									<span class="fl">{{ item.detail.chargeMode | chargeModeFilter }}</span>
								</li>									
								<li class="clearfix" v-if="item.detail.chargeMode == 1">
									<label class="fl">升级次数</label>
									<span class="fl sense-ellipsis package-num">{{ item.detail.upgradeCount + '/' + item.detail.upgradeTotal }} (剩余/总量)</span>
								</li>
								<li class="clearfix" v-if="item.detail.chargeMode == 2">
									<label class="fl">硬件锁数量</label>
									<span class="fl sense-ellipsis package-num">{{ item.detail.dongleCount + '/' + item.detail.dongleTotal }} (剩余/总量)</span>
								</li>
								<li class="clearfix" v-if="item.detail.chargeMode == 2 && item.detail.donglePeriod">
									<label class="fl">硬件锁周期</label>
									<span class="fl">{{ item.detail.donglePeriod | donglePeriodFilter }}</span>
								</li>
								<li class="clearfix" v-if="!item.detail.donglePeriod">
									<label class="fl">到期时间</label>
									<span class="fl">{{ item.expireTime }}</span>
								</li>
							</ul>
							<div class="card-new-footer clearfix">
								<el-popover placement="bottom" width="280" trigger="click">
									<el-form size="small" label-width="110px">
										<el-form-item label="套餐序列号">
											<div class="sense-text">
												<span class="fl sense-ellipsis sense-copy-text">{{ item.assetGuid }}</span>
												<a class="fr ssicon ss-copy" href="javascript:;" title="复制" 
													v-clipboard:copy="item.assetGuid" 
													v-clipboard:success="copySuccess"></a>	
											</div>						
										</el-form-item>	
										<div v-if="item.packageType == 1">
											<el-form-item label="许可形式">
												<div class="sense-text">{{ item.detail.licenseForm | licenseFormFilter }}</div>						
											</el-form-item>	
											<el-form-item label="系统平台" v-if="item.detail.licenseForm==2">
												<div class="sense-text" v-if="item.detail.platform == 7" style="position: relative;top: -2px;">
													传统 (
													<em title="Windows" class="ssicon ss-windows"></em>
													<em title="Linux" class="ssicon ss-linux"></em>
													<em title="Mac" class="ssicon ss-mac"></em>
													)
												</div>
												<div class="sense-text" v-if="(item.detail.platform & 24) > 0" style="position: relative;top: -2px;">
													智能(
													<em title="Android" class="ssicon ss-android"></em>
													<em title="ARM Linux" class="arm-linux-icon"></em>
													)
												</div>						
											</el-form-item>	
											<el-form-item label="许可周期">
												<div class="sense-text">{{ item.detail.licensePeriod | licensePeriodFilter }}</div>
											</el-form-item>		
											<el-form-item label="使用计数" v-if="item.detail.licenseForm==1">
												<div class="sense-text">{{ item.detail.useCount?item.detail.useCount:'--' }}</div>		
											</el-form-item>	
											<el-form-item label="许可类型" v-if="item.detail.licenseForm==2 && item.detail.platform == 7">
												<div class="sense-text">{{ item.detail.hasConcurrent | concurrentFilter(item.detail.concurrentType, item.detail.concurrent) }}</div>		
											</el-form-item>
											<el-form-item label="同时绑定数" v-if="item.detail.licenseForm==2 && ((item.detail.platform == 7 && item.detail.hasConcurrent==false) || (item.detail.platform & 24) > 0)">
												<div class="sense-text">{{ item.detail.bindLimit }}</div>		
											</el-form-item>		
											<el-form-item label="累积绑定数" v-if="item.detail.licenseForm==2 && item.detail.hasConcurrent==false && item.detail.platform == 7">
												<div class="sense-text">{{ item.detail.maxBound }}</div>			
											</el-form-item>	
											<el-form-item label="许可数量" style="margin-top: 10px;">
												<div class="sense-text">{{ item.detail.licenseCount | commonFilter }}/{{ item.detail.licenseTotal | commonFilter }} (剩余/总量)</div>		
											</el-form-item>
										</div>										

										<el-form-item label="更新次数" v-if="item.packageType == 2">
											<div class="sense-text">{{ item.detail.updateCount | commonFilter }}/{{ item.detail.updateTotal | commonFilter }} (剩余/总量)</div>		
										</el-form-item>

										<div v-if="item.packageType == 3">
											<el-form-item label="计费方式">
												<div class="sense-text">{{ item.detail.chargeMode | chargeModeFilter }}</div>		
											</el-form-item>
											<el-form-item label="升级次数" v-if="item.detail.chargeMode == 1">
												<div class="sense-text">{{ item.detail.upgradeCount + '/' + item.detail.upgradeTotal }} (剩余/总量)</div>	
											</el-form-item>
											<el-form-item label="硬件锁数量" v-if="item.detail.chargeMode == 2">
												<div class="sense-text">{{ item.detail.dongleCount + '/' + item.detail.dongleTotal }} (剩余/总量)</div>		
											</el-form-item>
											<el-form-item label="硬件锁周期" v-if="item.detail.chargeMode == 2">					
												<div class="sense-text">{{ item.detail.donglePeriod | donglePeriodFilter }}</div>
											</el-form-item>
										</div>

										<el-form-item label="套餐到期时间">
											<div class="sense-text">{{ item.expireTime | expireTimeFilter }}</div>
										</el-form-item>	
									</el-form>
									<!-- <el-button size="small" type="primary" class="fr" plain slot="reference">查看详情</el-button> -->
									<a href="javascript:;" class="link fl" slot="reference">查看详情</a>
								</el-popover>
								<a href="javascript:;" class="link fr" @click="countRecord(item)">使用记录</a>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</div>
			<div class="sense-table-pager" v-if="licenseObj.total>0">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="licenseObj.currentPage"
					:page-sizes="[9,18,27]"
					:page-size="licenseObj.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="licenseObj.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {
				tabsActive: '1',
				//许可套餐				
				licenseSearchObj: {
					packageName: '',
					status: '1'
				},
				licenseObj: {
					currentPage: 1,
					pageSize: 9,
					total: 0
				},
				noDataObj: {
					status: '1'
				},
				isReady: false,
				licenseListData: [],
			}
		},
		filters: {
			//许可形式filter
			licenseFormFilter: function(val) {
				if (val == 1) {
					return '云锁';
				} else {
					return '软锁';
				};
			},
			//许可周期filter
			licensePeriodFilter: function(val) {
				if (val == 2147483647) {
					return '永久';
				} else {
					return val + '天';
				};
			},
			//硬件锁周期filter
			donglePeriodFilter: function(val) {
				if (val) {
					return val + '天';
				} else {
					return '--';
				};
			},
			//套餐有效期filter
			packagePeriodFilter: function(val) {
				if (val == 2147483647) {
					return '--';
				} else {
					return val + '天';
				};
			},
			//套餐失效日期filter
			expireTimeFilter: function(val) {
				if (!val) {
					return '--';
				} else {
					return val;
				};
			},
			//计费方式filter
			chargeModeFilter: function(val) {
				if (val == 1) {
					return '按升级次数';
				} else if (val == 2) {
					return '按锁数量';
				} else {
					return '不限';
				};
			},
			commonFilter: function(val) {
				if (val == 2147483647) {
					return '不限';
				} else {
					return val;
				};
			},
			//套餐状态filter
			statusFilter: function(val) {
				switch(val) {
					case 1:
						return '正常';
						break;
					case 2:
						return '已用完';
						break;
					case 3:
						return '已过期';
						break;
				};
			},
			//并发方式filter
			concurrentFilter: function(hasConcurrent, concurrentType, concurrent) {
				if (hasConcurrent == false) {
					return '单机许可';
				} else {
					var concurrentTypeName = concurrentType=='process'?'进程':'会话';
					return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
				};
			},
		},
		methods: {
			//许可套餐start
			getLicenseList() {
				let url = '/package/asset/list.do';
				let param = this.licenseSearchObj;
				param.currentPage = this.licenseObj.currentPage;
				param.pageSize = this.licenseObj.pageSize;

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.licenseListData = response.data.rows;
						this.licenseObj.total = response.data.records;
						this.noDataObj.status = this.licenseSearchObj.status;
						this.isReady = true;
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});		
			},
			//许可套餐使用记录
			countRecord(row) {
				sessionStorage.setItem('status', this.licenseSearchObj.status);

				if (row.packageType == 3) {  //硬件锁
					this.$router.push({
		          		path: '/donglePackageRecord',
			            query: {
			            	assetGuid: row.assetGuid,
			            	packageName: row.packageName,
			            	chargeMode: row.detail.chargeMode
			            }
		        	});
				} else {
					this.$router.push({
		          		path: '/packageRecord',
			            query: {
			            	assetGuid: row.assetGuid,
			            	packageName: row.packageName
			            }
		        	});
				};				
			},
			//复制机器ID成功
		    copySuccess() {
		    	this.$message({
					message: '套餐序列号复制成功',
					type: 'success'
				});
		    },
			//搜索
			searchLicenseList() {
				this.licenseObj.currentPage = 1;
				this.getLicenseList();
			},
			//清空
			emptyLicenseSearch() {
				this.licenseSearchObj.packageName = '';
				this.licenseSearchObj.status = '1';
				this.licenseObj.currentPage = 1;
				this.getLicenseList();
			},	
			//切换每页显示条数
			handleSizeChange(val) {
				this.licenseObj.pageSize = val;
				this.getLicenseList();
			},
			//切换当前页
			handleCurrentChange(val) {
				this.licenseObj.currentPage = val;
				this.getLicenseList();
			},
			//许可套餐end
		},
		mounted() {
			let isFirst = sessionStorage.getItem('isFirst');
			if (isFirst == 1) {
				this.licenseSearchObj.status = sessionStorage.getItem('status');
				sessionStorage.setItem('isFirst', 0);
			}
			this.getLicenseList();
		},
	}
</script>

<style lang="scss">	

</style>


// WEBPACK FOOTER //
// MyPackage.vue?f17376c2